import { createContext, useContext, useMemo, useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const DragProviderContext = /*#__PURE__*/createContext(undefined);
export default function DragProvider({
  children
}) {
  const [currentDragData, setCurrentDragData] = useState();
  const value = useMemo(() => ({
    currentDragData,
    setCurrentDragData
  }), [currentDragData]);
  return /*#__PURE__*/_jsx(DragProviderContext.Provider, {
    value: value,
    children: children
  });
}
export function useDraggedObject() {
  const context = useContext(DragProviderContext);
  if (context === undefined) {
    throw new Error('useDraggedObject must be used within a DragProvider');
  }
  return context;
}